export const MIN_LENGTH_RULE_NAME = "min_length";
/**
 * Validates that a string has at least a minimum length.
 */
export const Validator = {
    name: MIN_LENGTH_RULE_NAME,
    errorMessage: `This field must be at least :${MIN_LENGTH_RULE_NAME} characters.`,
    validate: (value, requirement) => value.toString().length >= Number(requirement),
};
